import { analyticsUtils } from 'utils/analytics-utils';

/**
 * Событие срабатывает, когда нажимаешь на кнопку "В корзину"
 */

export const gaAddToCart = ({
  id,
  name,
  price,
  quantity,
}: {
  id: string;
  name: string;
  price: number;
  quantity: number;
}) =>
  analyticsUtils.sendEvent('GA:addToCart', {
    elementType: 'button',
    elementBlock: 'productDetail / calc', // блок, в котором расположен элемент
    elementName: 'Результат по размерам',
    elementText: 'В корзину',
    productName: name, // название товара
    productId: id, // артикул товара
    productPrice: price, // стоимость единицы товара
    productQuantity: quantity, // на какое количество единиц изменилось количество товара
    productBelong: 'LeroyMerlin', // принадлежность товара: LeroyMerlinMarketplace - для товаров Маркетплейс, Longtail - для товаров longtail, LeroyMerlin - для товаров Леруа Мерлен
  });
